<template>
  <ons-page id="auto-download-settings">
    <app-bar :title="$t('account.auto_download_settings')" :enable-home="false" />
    <v-ons-progress-bar indeterminate class="app-bar-progress" v-show="loading"></v-ons-progress-bar>
    <form action="" class="form">
      <ons-list v-show="!loading">
        <v-ons-list-item
          v-for="(channel, index) in channels"
          :key="channel.id"
        >
          <div class="left"><img-with-placeholder :src="constants.phImg48x48" :data-src="sizeImg(channel.image_base_url, 48, 48)" :alt="channel.image.alt_text" class="round-max" /></div>
          <div class="center">{{ channel.title }}</div>
          <div class="right por-rm switch-wp">
            <v-ons-switch
              :modelProp="channel.auto_download_enabled"
              :disabled="channelLoading[index] || isOffline"
              @change="toggleAutoDownload($event, index)"
            />
            <icon-progress-circular v-show="channelLoading[index]" />
          </div>
        </v-ons-list-item>
      </ons-list>
    </form>
    <v-ons-toast :visible="shouldShowGoOnlineToast" animation="ascend">
      {{ $t("messages.go_online_to_change_settings") }}
      <button @click="goOnline">{{ $t("ui.go_online") }}</button>
    </v-ons-toast>
  </ons-page>
</template>

<script>
import AppBar from '@/components/AppBar.vue';
import Channel from '@/models/Channel';

export default {
  name: 'auto-download-settings',
  components: {
    'app-bar': AppBar
  },

  data() {
    return {
      loading: true,
      channelLoading: {},
    };
  },

  computed: {
    channels() {
      return Channel.query().where('is_subscribed', true).get();
    },
  },

  methods: {
    toggleAutoDownload(event, index) {
      if (!event.isInteractive) { return; }
      let that = this;
      this.loading = true;
      this.channelLoading[index] = true;
      this.channels[index].toggleAutoDownload(this.currentUser.id)
        .catch(function (error) {
          console.log(error);
          that.showSomethingWrongToast();
        }).finally(() => {
          this.loading = false;
          this.channelLoading[index] = false;
        });
    },
  },

  created() {
    if (this.isOffline) {
      this.loading = false;
      return;
    }
    let that = this;
    this.loading = true;
    Channel.fetchAllSubscribedChannels(this.currentUser.id)
      .catch(function (error) {
        console.log(error);
        that.showSomethingWrongToast();
      }).finally(() => {
        this.loading = false;
      });
  },
};
</script>
